import { createContext, useContext } from "react";
const PortalProviderContext = createContext(null);
PortalProviderContext.displayName = "Interface.PortalProviderContext";
function usePortalProvider(override) {
  const context = useContext(PortalProviderContext);
  if (override) {
    return override;
  } else {
    if (!context) {
      throw new Error("`usePortalProvider()` must be used within a `<PortalProvider>`, specifically within a `<PortalProviderContext.Provider>`");
    }
    return context.current;
  }
}
export {
  PortalProviderContext,
  usePortalProvider
};
//# sourceMappingURL=contexts.js.map
